export enum WorkloadsTableTab {
  VERTICAL_OPTIMIZATION = 'VERTICAL_OPTIMIZATION',
  HORIZONTAL_OPTIMIZATION = 'HORIZONTAL_OPTIMIZATION',
}
